<template lang="pug">
.multi-select
  .tags.rows(v-if="value.length")
    .tag.row.center(@click="select(tag)" v-for="tag in value") {{ tag }}
  .select
    input(type="text" :value="filterSTR || (metadata && metadata.autocomplete && value[0])"
          @input="filterSTR = $event.target.value"
          @focus="index = null;open = true"
          @blur="open = false" @keydown.up="up"
          @keydown.down="down" @keydown.enter="select()"
          @keydown.delete="filterSTR.length === 0 && unselect()")
    .options(:class="{ open }")
      div(:class="{ highlight: index === k, selected: value.includes(v) }"
            @click="select(v, true)" v-for="v, k in options") {{ v }}
</template>
<script>
export default {
  props: ['data', 'metadata', 'value'],
  data() {
    return {
      index: null,
      filterSTR: '',
      open: false,
    }
  },
  computed: {
    filter_badge() {
      return this.$root.filters.filter((v, k) => v && k !== 'domain').v().sum('length')
    },
    options() {
      const regex = text => new RegExp(text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i')
      const options = this.data.filter(d => !this.filterSTR || regex(this.filterSTR).test(this.t[d]) || regex(this.filterSTR).test(d))
      if (this.index > options.length) this.index = null
      return options
    },
  },
  methods: {
    select(item, close) {
      if (this.metadata && this.metadata.autocomplete && !item && this.index === null) { // HACK
        this.$emit('change', this.filterSTR)
        this.filterSTR = ''
        if (close) this.open = false
        return
      }
      if (this.options.length === 0) return
      if (!item) item = this.options[this.index || 0]
      this.$emit('change', item)
      this.filterSTR = ''
      if (close) this.open = false
    },
    unselect() {
      if (this.metadata && this.metadata.autocomplete) return // HACK
      this.$emit('change', this.value.last())
      this.index = null
    },
    up() {
      this.index = Math.max(0, this.index - 1)
      this.$el.querySelector('.options').children[this.index].scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' })
    },
    down() {
      this.index = Math.min(this.options.length - 1, this.index + 1)
      this.$el.querySelector('.options').children[this.index].scrollIntoView({ behavior: 'instant', block: 'end', inline: 'nearest' })
    },
  }
}
</script>
<style>
.multi-select .select { position: relative;display: flex;min-width: 200px;max-width: 200px;height: 32px;border: 1px solid #dadee8;border-radius: var(--border-radius); }
.multi-select .tags::-webkit-scrollbar { display: none; }
.multi-select .tags { overflow: -moz-scrollbars-none;-ms-overflow-style: none; }
.multi-select .tags { overflow: auto;display: flex; }
.multi-select .tag { display: flex;align-items: center;margin: 2px;padding: 4px 8px;color: var(--text);background: white;border: 1px solid #dadee8;white-space: nowrap; }
.multi-select .tag::after { display: inline-block;width: 13px;height: 13px;content: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%234f5460"><path xmlns="http://www.w3.org/2000/svg" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>'); }
.multi-select .select input { flex: 50px;min-width: 50px;margin: 0;background: white;border: none;font-size: 100%; }
.multi-select .select .options { z-index: 10;position: absolute;top: 30px;left: -1px;overflow: auto;visibility: hidden;opacity: 0;max-height: 170px;width: calc(100% + 2px);background: white;border: 1px solid #dadee8;transition: var(--transition); }
.multi-select .select .options.open { visibility: visible;opacity: 1; }
.multi-select .select .options > * { padding: 10px; }
.multi-select .select .options .selected { background: hsl(51, 100%, 80%, 1); }
.multi-select .select .options .highlight { background: hsl(51, 100%, 90%, 1); }
.multi-select .tag:hover { cursor: pointer;background: hsl(51, 100%, 90%, 1); }
.multi-select .select .options > *:hover { cursor: pointer;background: hsl(51, 100%, 90%, 1); }
.multi-select .select .icon { position: absolute;top: 4px;right: 8px;pointer-events: none;transform: rotate(90deg); }
.multi-select .select .icon svg { width: 12px;height: 12px;fill: var(--inactive); }
</style>
